import React, { Component } from "react";
import LoadingCell from "./LoadingCell";

class LoadingView extends Component {
  render() {
    return (
      <div
        style={{
          direction: this.props.language == "english" ? "ltr" : "rtl",
          marginBottom: 50,
        }}
      >
        <LoadingCell />
        <LoadingCell />
        <LoadingCell />
        <LoadingCell />
      </div>
    );
  }
}

export default LoadingView;
